<div class="d-flex flex-column content-description-profile">
  <div>
    <div>
      <span class="fs-5 fw-extrabold">Ventas anuales</span>
    </div>
    <div>
      <span class="text-black">Tus ventas anuales del {{ yearCurrent }} ascienden a un total de <span class="text-blue fw-extrabold">$ {{ dashboard?.anio.monto_total ? dashboard.anio.monto_total : '0.00' }}</span><br>Esta suma esta calculada hasta el mes actual.</span>
    </div>
  </div>
  <div>
    <div>
      <span class="fs-5 fw-extrabold">Puntos Kaizen anuales</span>
    </div>
    <div>
      <span class="text-black">Tus puntos Kaizen del {{ yearCurrent }} ascienden a un total de <span class="text-blue fw-extrabold">{{ dashboard?.anio.puntos_kaizen ? dashboard.anio.puntos_kaizen : '0' }} puntos</span><br>Esta suma esta calculada hasta el mes actual.</span>
    </div>
  </div>
  <div>
    <div>
      <span class="fs-5 fw-extrabold">Clientes activos</span>
    </div>
    <div>
      <span class="text-black">Actualmente cuentas con un total de <span class="text-blue fw-extrabold">{{ dashboard?.anio.usuarios_totales ? dashboard.anio.usuarios_totales : '0' }} clientes activos</span></span>
    </div>
  </div>
</div>